import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=da990e6a&scoped=true&lang=html&"
import script from "./Plan.vue?vue&type=script&lang=js&"
export * from "./Plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da990e6a",
  null
  
)

export default component.exports